var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.9872 12.6L13.8872 7.7C14.0872 7.5 14.3205 7.40417 14.5872 7.4125C14.8539 7.42083 15.0872 7.525 15.2872 7.725C15.4705 7.925 15.5664 8.15833 15.5747 8.425C15.583 8.69167 15.4872 8.925 15.2872 9.125L8.6872 15.725C8.5872 15.825 8.47886 15.8958 8.3622 15.9375C8.24553 15.9792 8.12053 16 7.9872 16C7.85386 16 7.72886 15.9792 7.6122 15.9375C7.49553 15.8958 7.3872 15.825 7.2872 15.725L0.687195 9.125C0.503862 8.94167 0.412195 8.7125 0.412195 8.4375C0.412195 8.1625 0.503862 7.925 0.687196 7.725C0.887195 7.525 1.1247 7.425 1.3997 7.425C1.6747 7.425 1.91219 7.525 2.1122 7.725L6.9872 12.6L6.9872 1.425C6.9872 1.14167 7.08303 0.904165 7.2747 0.712499C7.46636 0.520832 7.70386 0.425 7.9872 0.425C8.27053 0.425 8.50803 0.520832 8.6997 0.712499C8.89136 0.904166 8.9872 1.14167 8.9872 1.425L8.9872 12.6Z",
    fill: "#20242B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrowDown.147095e9a1c9383b001347d96f83ca36.svg";
export { ForwardRef as ReactComponent };